import React from "react";
import "./OnboardingScreen.css";
import {
  Button,
  Checkbox,
  Hidden,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
  Chip,
  Input,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  withStyles,
  WithStyles,
  createStyles,
  Radio,
  RadioGroup,
  RadioProps,
} from "@material-ui/core";
import logo from "../../../assets/ReadleeLogoRed.png";
import googleIcon from "../../../assets/icons/google-icon.jpeg";
import { RootState } from "../../../state/configureStore";
import { connect } from "react-redux";
import FirebaseService from "../../../services/firebase/FirebaseService";
import Loading from "../../Loading/Loading";
import OnboardingAssignment from "../../../interfaces/OnboardingAssignment";
import firebase from "firebase";
import { Theme } from "@material-ui/core/styles";
import CleverClass from "../../../interfaces/CleverClass";
import { GENERAL_MAX_LENGTH } from "../../../utils/stringFormatting";
import { RouteComponentProps } from "react-router";
import { ReadleeGoogleCourse } from "../../../interfaces/Google";
import { ReadleeColors } from "../../../themes/default";

// Resizable local styles
const styles = (theme: Theme) =>
  createStyles({
    bigBold: {
      fontSize: "32px",
      fontWeight: "bold",
      [theme.breakpoints.down("xs")]: {
        fontSize: "26px",
      },
    },
    subtext: {
      fontSize: "20px",

      [theme.breakpoints.down("xs")]: {
        fontSize: "20px",
      },
    },
    label: {
      fontSize: "20px",
      fontWeight: "bold",
      [theme.breakpoints.down("xs")]: {
        fontSize: "20px",
      },
      marginTop: "35px",
      marginBottom: "10px",
    },
    assignment: {
      marginTop: "40px",
      marginBottom: "30px",
    },
    titleContainer: {
      fontSize: "22px",
    },
    title: {
      fontWeight: "bold",
      marginBottom: "10px",
      marginRight: "4px",
    },
    preview: {
      fontSize: "20px",
      textTransform: "none",
      textDecoration: "underline",
      padding: "0px",
    },
    logo: {
      width: "200px",
      height: "40px",
      [theme.breakpoints.down("xs")]: {
        width: "150px",
        height: "30px",
      },
    },
    continueButton: {
      textTransform: "none",
    },
    skip: {
      textTransform: "none",
      marginLeft: "10px",
    },
    input: {
      maxWidth: "400px",
    },
  });

const PapayaRadio = withStyles({
  root: {
    "&$checked": {
      color: ReadleeColors.accentRed,
    },
  },
  checked: {},
})((props: RadioProps) => <Radio color="default" {...props} />);

interface OnboardingScreenState {
  stage: number;
  name: string;
  customClassName: string;
  school: string;
  grades: Array<string>;
  gradeList: Array<string>;
  subjects: Array<string>;
  customSubject: string;
  ellPercentage: string;
  googleClasses: Array<ReadleeGoogleCourse>;
  googleClassesToBeMade: Array<ReadleeGoogleCourse>;
  assignmentsToAdd: Array<string>;
  assignments: Map<string, OnboardingAssignment>;
  cleverClasses: Array<CleverClass>;
  cleverClassesToBeMade: Array<CleverClass>;
}

interface DisplayAssignmentType {
  id: string;
  description: string;
  order: number;
  grades: string;
  title: string;
}

type OnboardingScreenProps = ReturnType<typeof mapStateToProps> & RouteComponentProps & WithStyles<typeof styles>;
class OnboardingScreen extends React.Component<OnboardingScreenProps, OnboardingScreenState> {
  constructor(props: OnboardingScreenProps) {
    super(props);
    this.state = {
      stage: 1,
      name: "",
      customClassName: "",
      school: "",
      grades: [],
      gradeList: [],
      subjects: [],
      customSubject: "",
      ellPercentage: "",
      googleClasses: [],
      googleClassesToBeMade: [],
      assignmentsToAdd: [],
      assignments: new Map(),
      cleverClasses: [],
      cleverClassesToBeMade: [],
    };
  }

  override componentDidMount() {
    const location = this.props.location as { state?: { cleverClasses?: CleverClass[] } };
    const cleverClasses: CleverClass[] = location?.state?.cleverClasses || [];
    if (cleverClasses.length > 0) {
      this.setState({ cleverClasses });
    }
  }

  displayCleverClasses = () =>
    this.state.cleverClasses.map(e => (
      <div className="content">
        <input
          onChange={v => this.manageCleverClass(v.target.checked, e)}
          style={{ marginTop: "10px" }}
          type="checkbox"
        />
        <div
          style={{
            fontSize: "14px",
            marginTop: "7px",
          }}
        >
          {e.data.name}
        </div>
      </div>
    ));

  // manage which clever classes are selected
  manageCleverClass(shouldAdd: boolean, target: CleverClass) {
    this.setState(state => ({
      cleverClassesToBeMade: shouldAdd
        ? [...state.cleverClassesToBeMade, target]
        : state.cleverClassesToBeMade.filter(x => x.data.id !== target.data.id),
    }));
  }

  // Store onboarding assignments from Readlee Settings in state
  storeAssignments() {
    this.props.onboardingAssignments.forEach(async (assignment: OnboardingAssignment) => {
      const currentAssignments = this.state.assignments;
      const title = (await FirebaseService.getAssignment(assignment.assignmentId)).title || "";
      currentAssignments.set(title, assignment);
      if (currentAssignments !== this.state.assignments) this.setState({ assignments: currentAssignments });
    });
  }

  // Display user's google classes
  displayGoogleClasses = () =>
    this.state.googleClasses.map(e => (
      <div className="content">
        <input
          onChange={v => this.manageGoogleClass(v.target.checked, e)}
          style={{ marginTop: "10px" }}
          type="checkbox"
        />
        <div
          style={{
            fontSize: "14px",
            marginTop: "7px",
          }}
        >
          {e.name}
        </div>
      </div>
    ));

  // manage which google classes are selected
  manageGoogleClass(shouldAdd: boolean, target: ReadleeGoogleCourse) {
    this.setState(state => ({
      googleClassesToBeMade: shouldAdd
        ? [...state.googleClassesToBeMade, target]
        : state.googleClassesToBeMade.filter(x => x.id !== target.id),
    }));
  }

  // manage which google classes are selected
  manageGrades(shouldAdd: boolean, target: Array<string>) {
    const gradesCopy = this.state.grades;
    if (shouldAdd) {
      target.forEach(t => {
        gradesCopy.push(t);
      });
    } else {
      target.forEach(t => {
        gradesCopy.splice(gradesCopy.indexOf(t), 1);
      });
    }
    this.setState({ grades: gradesCopy });
  }

  // manage which google classes are selected
  manageSubjects(shouldAdd: boolean, target: string) {
    const subjectsCopy = this.state.subjects;
    if (shouldAdd) {
      subjectsCopy.push(target);
    } else {
      subjectsCopy.splice(subjectsCopy.indexOf(target), 1);
    }
    this.setState({ subjects: subjectsCopy });
  }

  // manage which google classes are selected
  manageAssignments(shouldAdd: boolean, target: string) {
    const assignmentsToAdd = this.state.assignmentsToAdd;
    if (shouldAdd) {
      assignmentsToAdd.push(target);
    } else {
      assignmentsToAdd.splice(assignmentsToAdd.indexOf(target), 1);
    }

    this.setState({ assignmentsToAdd: assignmentsToAdd });
  }

  // create classes from google or inputted class name
  async createClasses() {
    if (!this.props.currentUser) return [];

    const classIds: string[] = [];
    if (this.state.googleClassesToBeMade.length > 0) {
      for (const currentClass of this.state.googleClassesToBeMade) {
        const classStudents: string[] = [];
        if (currentClass.students === undefined) currentClass.students = [];
        currentClass.students.forEach(e => classStudents.push(e.profile.emailAddress));

        // create class with students and store ID
        const result = await FirebaseService.createClass(
          currentClass.name,
          this.props.currentUser.displayName,
          this.props.currentUser.email,
          this.props.currentUser.uid,
          currentClass.id,
          classStudents,
        );

        if (result) {
          classIds.push(result);
        }
      }
    } else if (this.state.cleverClassesToBeMade.length > 0) {
      for (const { data: currentClass } of this.state.cleverClassesToBeMade) {
        currentClass.students = currentClass.students.map(cleverId => `clever+${cleverId}@readlee.com`);
        // create class with students and store ID
        const result = await FirebaseService.createClass(
          currentClass.name,
          this.props.currentUser.displayName,
          this.props.currentUser.email,
          this.props.currentUser.uid,
          null,
          currentClass.students,
        );
        if (result) {
          classIds.push(result);
        }
      }
    } else if (this.state.customClassName.length > 0) {
      const result = await FirebaseService.createClass(
        this.state.customClassName,
        this.props.currentUser.displayName,
        this.props.currentUser.email,
        this.props.currentUser.uid,
        null,
        [],
      );

      if (result) {
        classIds.push(result);
      }
    }

    return classIds;
  }

  // add checked assignments to each inputted class id
  async addAssignments(ids: string[]) {
    this.state.assignments.forEach((assignment: OnboardingAssignment) => {
      this.manageAssignments(true, assignment.assignmentId);
    });
    for (const classId of ids) {
      for (const assignment of this.state.assignmentsToAdd) {
        await FirebaseService.addAssignmentToClass(assignment, classId);
      }
    }
  }

  // Display onboarding assignments from Readlee Settings, with description
  displayOnboardingAssignments() {
    const assignments: DisplayAssignmentType[] = [];
    this.state.assignments.forEach((assignment: OnboardingAssignment, title) => {
      assignments.push({
        id: assignment.assignmentId,
        description: assignment.description,
        order: assignment.order,
        grades: assignment.grades,
        title: title,
      });
    });

    return assignments
      .sort((a, b) => (a.order > b.order ? 1 : -1))
      .map(assignment => (
        <div className={this.props.classes.assignment}>
          <span className={this.props.classes.titleContainer}>
            <span className={this.props.classes.title}>{assignment.title} </span> (
            <Button
              className={this.props.classes.preview}
              onClick={() =>
                window.open(window.location.origin + `/Book?assignmentid=${assignment.id}&classid=&isPreview=true`)
              }
              color="primary"
            >
              preview
            </Button>
            )
          </span>
          <div style={{ maxWidth: "600px" }}>{assignment.description}</div>
        </div>
      ));
  }

  /* MAIN ONBOARDING PAGES*/

  // get school, grades, and class subject info
  aboutYouPage() {
    const subjects = [
      "General Education",
      "Language Arts",
      "Mathematics",
      "Science",
      "Social Studies",
      "Foreign Language",
      "Music",
    ];

    const updateGrades = (event: React.ChangeEvent<{ value: unknown }>) => {
      const gradeList = event.target.value as string[];
      const grades: string[] = [];
      gradeList.forEach(group => {
        switch (group) {
          case "Elementary (K-5)":
            grades.push("K", "1", "2", "3", "4", "5");
            break;
          case "Middle School (6-8)":
            grades.push("6", "7", "8");
            break;
          case "High School (9-12)":
            grades.push("9", "10", "11", "12");
            break;
          case "Other":
            grades.push("Other");
            break;
        }
      });
      this.setState({ gradeList: gradeList, grades: grades });
    };
    return (
      <div>
        <div style={{ height: "50px" }} />
        <span>
          <span className={this.props.classes.bigBold}>Welcome to Readlee,</span>
          <span className={this.props.classes.bigBold} style={{ marginLeft: "0.25em", color: "#FF8F78" }}>
            {this.props.currentUser?.displayName ?? ""}
          </span>
          <span className={this.props.classes.bigBold}>!</span>
        </span>
        <div className={this.props.classes.subtext} style={{ marginTop: "5px", marginBottom: "20px" }}>
          We're excited to get to know you better.
        </div>
        <FormLabel className={this.props.classes.label} component="legend">
          What is the name of your school?
        </FormLabel>
        <TextField
          value={this.state.school}
          variant="outlined"
          id="school"
          label="School"
          onChange={val => this.setState({ school: val.target.value })}
          fullWidth
          className={this.props.classes.input}
          inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
        />
        <div className="content" style={{ display: "flex", flexDirection: "column" }}>
          <FormLabel className={this.props.classes.label} component="legend">
            What grades do you teach?
          </FormLabel>
          <FormControl className="chipInput">
            <InputLabel variant="outlined">Grades</InputLabel>
            <Select
              disableUnderline
              multiple
              className={this.props.classes.input}
              value={this.state.gradeList}
              onChange={updateGrades}
              inputProps={{ MenuProps: { disableScrollLock: true, getContentAnchorEl: null } }}
              input={<Input />}
              renderValue={selected => (
                <div>
                  {(selected as string[]).map(value => (
                    <Chip key={value} label={value} />
                  ))}
                </div>
              )}
            >
              <MenuItem key="Elementary" value="Elementary (K-5)">
                Elementary (K-5)
              </MenuItem>
              <MenuItem key="Middle" value="Middle School (6-8)">
                Middle School (6-8)
              </MenuItem>
              <MenuItem key="High" value="High School (9-12)">
                High School (9-12)
              </MenuItem>
              <MenuItem key="Other" value="Other">
                Other
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl focused={false}>
            <FormLabel className={this.props.classes.label} component="legend">
              What subjects do you teach?
            </FormLabel>
            <FormGroup>
              {subjects.map(s => (
                <FormControlLabel
                  className={this.props.classes.input}
                  control={
                    <Checkbox
                      checked={this.state.subjects.includes(s)}
                      onChange={v => this.manageSubjects(v.target.checked, s)}
                      name="subject"
                      color="primary"
                      style={{ marginRight: "5px" }}
                    />
                  }
                  label={s}
                />
              ))}
              <TextField
                value={this.state.customSubject}
                variant="outlined"
                id="other"
                label="Other"
                onChange={val => this.setState({ customSubject: val.target.value })}
                fullWidth
                className={this.props.classes.input}
                inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
              />
            </FormGroup>
          </FormControl>
          <FormControl focused={false}>
            <FormLabel className={this.props.classes.label} component="legend">
              About what percentage of your students are English Language Learners?
            </FormLabel>
            <RadioGroup
              aria-label="ell"
              name="ell"
              value={this.state.ellPercentage}
              onChange={val => this.setState({ ellPercentage: val.target.value })}
              style={{ marginBottom: "30px" }}
            >
              <FormControlLabel value="Less than 5%" control={<PapayaRadio />} label="Less than 5%" />
              <FormControlLabel value="6-25%" control={<PapayaRadio />} label="6-25%" />
              <FormControlLabel value="26-50%" control={<PapayaRadio />} label="26-50%" />
              <FormControlLabel value="51-75%" control={<PapayaRadio />} label="51-75%" />
              <FormControlLabel value="76%-100%" control={<PapayaRadio />} label="76%-100%" />
            </RadioGroup>
          </FormControl>
        </div>
        <Button
          variant="contained"
          color="primary"
          className={this.props.classes.continueButton}
          disabled={
            (!this.state.customSubject.length && !this.state.subjects.length) ||
            !this.state.school.length ||
            !this.state.grades.length ||
            !this.state.ellPercentage.length
          }
          onClick={() => this.setState({ stage: 2 })}
          style={{ marginBottom: "30px" }}
        >
          Continue
        </Button>
      </div>
    );
  }

  // create custom class, or import from google, etc
  yourStudents() {
    return (
      <div>
        <div style={{ height: "50px" }} />
        <div className={this.props.classes.bigBold}>Now lets add your students.</div>
        {firebase.auth().currentUser?.providerData[0]?.providerId === "google.com" && (
          <div style={{ marginTop: "75px" }}>
            <div className={this.props.classes.label} style={{ marginBottom: "5px" }}>
              Import Students from:
            </div>
            <Button
              variant="outlined"
              style={{ backgroundColor: "white", marginBottom: "5px" }}
              onClick={() => {
                FirebaseService.getGoogleClassrooms().then(classes => {
                  this.setState({ googleClasses: classes, googleClassesToBeMade: [] });
                });
              }}
            >
              <img style={{ width: "12.5px", marginRight: "15px" }} src={googleIcon} alt="google" />
              Google Classroom
            </Button>
            {this.displayGoogleClasses()}
          </div>
        )}
        {this.state.cleverClasses.length > 0 && (
          <div style={{ marginTop: "75px" }}>
            <div className={this.props.classes.label} style={{ marginBottom: "5px" }}>
              Import Students from Clever:{" "}
            </div>
            {this.displayCleverClasses()}
          </div>
        )}
        <div className={this.props.classes.label} style={{ marginTop: "20px" }}>
          {(firebase.auth().currentUser?.providerData[0]?.providerId === "google.com" ||
            this.state.cleverClasses.length > 0) &&
            "Or"}{" "}
          Create A New Class
        </div>
        <TextField
          value={this.state.customClassName}
          variant="outlined"
          id="school"
          label="Class Name"
          onChange={val => this.setState({ customClassName: val.target.value })}
          fullWidth
          className={this.props.classes.input}
          inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
        />
        <div style={{ height: "30px" }} />
        <div style={{ display: "flex", flexDirection: "row", marginBottom: "30px" }}>
          <Button
            variant="contained"
            color="primary"
            className={this.props.classes.continueButton}
            disabled={
              !this.state.customClassName.length &&
              !this.state.googleClassesToBeMade.length &&
              !this.state.cleverClassesToBeMade.length
            }
            onClick={() => this.setState({ stage: 3 })}
          >
            Continue
          </Button>
          <Button
            className={this.props.classes.skip}
            onClick={async () => {
              if (!this.props.currentUser) return;
              const finalSubjects = this.state.subjects;
              if (this.state.customSubject.length > 0) finalSubjects.push(this.state.customSubject);
              await FirebaseService.setupNewTeacher(
                this.props.currentUser.uid,
                this.state.school,
                this.state.grades,
                finalSubjects,
                this.state.ellPercentage,
              ).then(() => {
                window.location.href = window.location.origin;
              });
            }}
          >
            Skip
          </Button>
        </div>
      </div>
    );
  }

  // add an assignment to first class(es)
  firstAssignment() {
    return (
      <div>
        <div style={{ height: "50px" }} />
        <span style={{ marginBottom: "10px" }}>
          <span className={this.props.classes.bigBold}>Awesome -</span>
          <span className={this.props.classes.bigBold} style={{ marginLeft: "0.25em", color: "#FF8F78" }}>
            you're almost there!
          </span>
        </span>
        <div className={this.props.classes.subtext} style={{ marginBottom: "20px", marginTop: "10px" }}>
          Finish by creating your first reading assignment.
        </div>
        {this.displayOnboardingAssignments()}
        <div style={{ height: "15px" }} />
        <div style={{ display: "flex", flexDirection: "row" }}>
          <Button
            variant="contained"
            color="primary"
            className={this.props.classes.continueButton}
            onClick={async () => {
              if (!this.props.currentUser) return;
              const finalSubjects = this.state.subjects;
              if (this.state.customSubject.length > 0) finalSubjects.push(this.state.customSubject);
              await FirebaseService.setupNewTeacher(
                this.props.currentUser.uid,
                this.state.school,
                this.state.grades,
                finalSubjects,
                this.state.ellPercentage,
              ).then(async () => {
                await this.addAssignments(await this.createClasses());
                window.location.href = window.location.origin;
              });
            }}
          >
            Create Assignment
          </Button>
          <Button
            className={this.props.classes.skip}
            onClick={async () => {
              if (!this.props.currentUser) return;
              const finalSubjects = this.state.subjects;
              if (this.state.customSubject.length > 0) finalSubjects.push(this.state.customSubject);
              await FirebaseService.setupNewTeacher(
                this.props.currentUser.uid,
                this.state.school,
                this.state.grades,
                finalSubjects,
                this.state.ellPercentage,
              ).then(async () => {
                await this.createClasses();
                window.location.href = window.location.origin;
              });
            }}
          >
            Skip
          </Button>
        </div>
      </div>
    );
  }

  // Header of onboarding and jumping between stages
  header() {
    return (
      <div className="content">
        <img className={this.props.classes.logo} alt="logo" src={logo} />
        <Hidden mdDown>
          <div style={{ width: "25px" }} />
          <div style={{ marginTop: "2px" }}>
            <Button
              style={{ color: this.state.stage === 1 ? "black" : "grey" }}
              onClick={() => this.setState({ stage: 1, grades: [], subjects: [] })}
            >
              About You
            </Button>
          </div>
          <div style={{ marginTop: "7.5px" }}>{">"}</div>
          <div style={{ marginTop: "2px" }}>
            <Button
              style={{ color: this.state.stage === 2 ? "black" : "grey" }}
              onClick={() => {
                if (
                  (this.state.customSubject.length > 0 || this.state.subjects.length > 0) &&
                  this.state.school.length > 0 &&
                  this.state.grades.length > 0
                )
                  this.setState({ stage: 2, googleClassesToBeMade: [], cleverClassesToBeMade: [] });
              }}
            >
              Your Students
            </Button>
          </div>
          <div style={{ marginTop: "7.5px" }}>{">"}</div>
          <div style={{ marginTop: "2px" }}>
            <Button
              style={{ color: this.state.stage === 3 ? "black" : "grey" }}
              onClick={() => {
                if (
                  (this.state.customSubject.length > 0 || this.state.subjects.length > 0) &&
                  this.state.school.length > 0 &&
                  this.state.grades.length > 0
                )
                  if (
                    this.state.customClassName.length > 0 ||
                    this.state.googleClassesToBeMade.length > 0 ||
                    this.state.cleverClassesToBeMade.length > 0
                  )
                    this.setState({ stage: 3 });
              }}
            >
              Set up your first assignment
            </Button>
          </div>
        </Hidden>
      </div>
    );
  }

  // routes between different pages in onboarding
  content() {
    switch (this.state.stage) {
      case 1:
        return this.aboutYouPage();
      case 2:
        return this.yourStudents();
      case 3:
        return this.firstAssignment();
      default:
        return this.aboutYouPage();
    }
  }

  // redirect to home if user is student
  override componentDidUpdate() {
    if (this.props.currentUser !== undefined) {
      if (this.props.currentUser.userType === "student") {
        this.props.history.replace("/Home");
      }
      // else if((this.props.currentUser).userType === 'teacher' &&
      // (this.props.currentUser).onboardingStatus === 'complete'){
      //     console.log((this.props.currentUser).userType, (this.props.currentUser).onboardingStatus)
      //     window.location.href = window.location.origin;
      // }
    }
    this.storeAssignments();
  }

  override render() {
    if (this.props.currentUser === undefined) {
      return <Loading />;
    }

    return (
      <div className="OnboardingScreen">
        <div className="content">
          <div className="left-content">
            {this.header()}
            {this.content()}
          </div>
          <Hidden mdDown>
            <div className="right-border" />
          </Hidden>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  currentUser: state.currentUserState.currentUser,
  onboardingAssignments: state.readleeSettingsState.onboardingAssignments,
  cloningFinished: state.readleeSettingsState.cloningFinished,
});

export default withStyles(styles)(connect(mapStateToProps)(OnboardingScreen));
